import { VALUES_DE } from '@monofront/business/constants';
import BadgeVegan from '@monofront/design-system/visuals/Icons/BadgeVegan';
import BadgeDemeter from '@monofront/design-system/visuals/Icons/BadgeDemeter';
import BadgeFairTrade from '@monofront/design-system/visuals/Icons/BadgeFairTrade';
import BadgeLactoseFree from '@monofront/design-system/visuals/Icons/BadgeLactoseFree';
import BadgeGlutenFree from '@monofront/design-system/visuals/Icons/BadgeGlutenFree';
import BadgeMadeInGermany from '@monofront/design-system/visuals/Icons/BadgeMadeInGermany';
import BadgeBioland from '@monofront/design-system/visuals/Icons/BadgeBioland';
import BadgeNaturland from '@monofront/design-system/visuals/Icons/BadgeNaturland';
import BadgeGerman from '@monofront/design-system/visuals/Icons/BadgeGerman';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import ListItem, { IValueData } from './ListItem';

interface IValuesProps {
  values: string[];
  size?: 'md' | 'lg';
  enableSidePanel?: boolean;
}

const GermanValues: React.FC<IValuesProps> = ({
  values,
  size = 'md',
  enableSidePanel = false,
}) => {
  const tCatalog = useTranslations('Catalog');

  const formattedValues = useMemo(
    () => values.map((value) => value.toUpperCase()),
    [values],
  );

  const valuesData = useMemo(
    (): { [x: string]: IValueData } => ({
      [VALUES_DE.VEGAN]: {
        Badge: (props) => <BadgeVegan {...props} />,
        label: tCatalog('tagVegan'),
        documentUid: 'vegan',
      },
      [VALUES_DE.DEMETER]: {
        Badge: (props) => <BadgeDemeter {...props} />,
        label: tCatalog('tagDemeter'),
        documentUid: 'demeter',
      },
      [VALUES_DE.GLUTENFREE]: {
        Badge: (props) => <BadgeGlutenFree {...props} />,
        label: tCatalog('tagGlutenFree'),
        documentUid: 'gluten-free',
      },
      [VALUES_DE.LACTOSEFREE]: {
        Badge: (props) => <BadgeLactoseFree {...props} />,
        label: tCatalog('tagLactoseFree'),
        documentUid: 'lactose-free',
      },
      [VALUES_DE.MADEINGERMANY]: {
        Badge: (props) => <BadgeMadeInGermany {...props} />,
        label: tCatalog('tagMadeInGermany'),
        documentUid: 'made-in-germany',
      },
      [VALUES_DE.FAIRTRADE]: {
        Badge: (props) => <BadgeFairTrade {...props} />,
        label: tCatalog('tagFairTrade'),
        documentUid: 'fair-trade',
      },
      [VALUES_DE.BIOLAND]: {
        Badge: (props) => <BadgeBioland {...props} />,
        label: tCatalog('tagBioland'),
        documentUid: 'bio-land',
      },
      [VALUES_DE.NATURLAND]: {
        Badge: (props) => <BadgeNaturland {...props} />,
        label: tCatalog('tagNaturland'),
        documentUid: 'naturland',
      },
      [VALUES_DE.GERMAN]: {
        Badge: (props) => <BadgeGerman {...props} />,
        label: tCatalog('tagGerman'),
      },
      [VALUES_DE.FAIRGEHANDELT]: {
        Badge: (props) => <BadgeFairTrade {...props} />,
        label: tCatalog('tagFairGehandelt'),
        documentUid: 'fair-gehandelt',
      },
    }),
    [tCatalog],
  );

  return (
    <>
      {formattedValues.map((value, index) => {
        const data = valuesData[value];

        if (!data) return null;

        return (
          <ListItem
            key={index}
            valueId={value}
            valueData={data}
            size={size}
            enableSidePanel={enableSidePanel}
            tagColor="tw-lf-tag-decorative-green"
          />
        );
      })}
    </>
  );
};

export default GermanValues;
